import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { PersonSchema } from './components/PersonSchema';
import { usePageMeta } from './hooks/usePageMeta';

export const PageMeta: React.FC = () => {
	const {
		data: { description, displayName, image, searchFriendlyDescription, title, canonicalUrl },
	} = usePageMeta();

	return (
		<>
			<Helmet>
				{canonicalUrl && <link rel="canonical" href={canonicalUrl}></link>}
				<title>{title}</title>
				<meta property="title" content={title} />
				<meta name="description" content={searchFriendlyDescription} />
				<meta property="og:description" content={description} />
				<meta property="og:image" content={image} />
				<meta property="og:title" content={displayName} />
				<meta property="og:type" content="website" />
				<meta property="twitter:image" content={image} />
				<meta property="twitter:image:alt" content={title} />
			</Helmet>
			<PersonSchema />
		</>
	);
};
